module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_notify-d72ec519451cd51ada21c7037e7c55dc.png";